export const titleCaseHandler = (str: string | null | undefined): string => {
    const titleCase = `${str?.[0]?.toUpperCase() ?? ''}${str?.slice(1)?.toLowerCase() ?? ''}`;
    return titleCase;
};
